import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const Stripes = () => {
    // Create a ScrollTrigger for the element
    gsap.registerPlugin(ScrollTrigger)

    document.querySelectorAll('[data-stripes]').forEach((element) => {
        ScrollTrigger.create({
            trigger: element,
            start: 'bottom bottom',
            // markers: true,
            onToggle: ({ progress }) => {
                if (progress > 0) {
                    element.classList.add('animate')
                }
            },
        })
    })

    return true
}

export default Stripes
